import React from "react";

const LoadingContainer = () => (
  <div
    className="loading-container"
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 29034,
      opacity: 1,
      background: "#FAFAFA"
    }}
  >
    <div />
    {Fraction.Brand.Graphics.logo.indexOf("logo_bookshelf.svg") >= 0 ? (
      <div className="innerContainer">
        <img src="/img/logo_bookshelf_dark.svg" />
        <br />
        <div className="loader animate">
          <div>
            <div />
          </div>
        </div>
      </div>
    ) : (
      <div className="innerContainer" style={{ width: 52, height: 52 }}>
        <div className="spinning" style={{ marginTop: 17 }} />
      </div>
    )}
  </div>
);

export default LoadingContainer;
